export function convertPxToNumber(value?: string) {
  if (value) {
    return parseFloat(value.replace('px', ''))
  }
}

export const isV2Ready = false

export function isDev(): boolean {
  return import.meta.env.VITE_ENVIRONMENT === 'development'
}

export const isIppon = import.meta.env.VITE_PRODUCTION === '1ppon'
